export const ANSWERS_LOCKED = 'AnswersLocked';
